import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@zola/zola-ui';

const ExtraFieldsMenu = ({ fields, onExtraSelect }) => {
  const options = fields.map(field => ({ value: field, label: field }));
  const facetList = {
    label: 'Add Another Detail',
    key: 'ADD_ANOTHER',
    options,
  };
  return (
    <Dropdown
      className="zola-list__dropdown"
      onSelect={val => onExtraSelect(val)}
      facetList={facetList}
    />
  );
};

ExtraFieldsMenu.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.string),
  onExtraSelect: PropTypes.func,
};

export default ExtraFieldsMenu;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/ExtraFieldsMenu.jsx